import { Serializer } from '@lib/store';
import { flightAvailabilityToCheckinInitialState } from './flight-availability-to-checkin.reducer';
import { FlightAvailabilityToCheckinState } from './flight-availability-to-checkin.state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flightAvailabilityToCheckinStorageDeserializer = (rawObject: any) => {
  return {
    ...flightAvailabilityToCheckinInitialState,
    model: rawObject && rawObject.model ? rawObject.model : null,
  } as FlightAvailabilityToCheckinState;
};

export const flightAvailabilityToCheckinStorageSync: Serializer<FlightAvailabilityToCheckinState> = {
  deserialize: flightAvailabilityToCheckinStorageDeserializer,
};
